import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Grid } from '@mui/material'
import { CaffeineOptions, CaffeinePressable } from '../../components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const caffeineProductNames = {
  'No Caffeine': 'Não consumo',
  Coffee: 'Café',
  'Energy Drink': 'Energético',
}

const CaffeinePressableList = ({
  caffeineProducts,
  selectedOptions,
  onSelectOption,
}) => {
  const [normalizedCaffeineProducts, setNormalizedCaffeineProducts] =
    useState(caffeineProducts)
  const [disableOptions, setDisableOptions] = useState(
    selectedOptions[0]?.isNoCaffeine,
  )

  const handleSelectOption = ({ option }) => {
    const optionIncluded = selectedOptions.find(
      product => product.id === option.id,
    )

    if (optionIncluded) {
      const removedOption = selectedOptions.filter(item => item.id != option.id)
      onSelectOption(removedOption)
      setDisableOptions(false)

      return
    }

    if (!option.isNoCaffeine && disableOptions) return

    if (option.isNoCaffeine) {
      onSelectOption([option])
      setDisableOptions(true)

      return
    }

    if (selectedOptions.length >= 3) {
      setDisableOptions(true)
      return
    }

    onSelectOption([...selectedOptions, option])
  }

  const isSelected = ({ optionId }) => {
    const optionIsSelected = selectedOptions.find(
      product => product.id === optionId,
    )

    if (optionIsSelected) return true

    return false
  }

  useEffect(() => {
    if (normalizedCaffeineProducts) {
      const newCaffeineProducts = normalizedCaffeineProducts.map(product => {
        return {
          ...product,
          name: caffeineProductNames[product.name] || product.name,
        }
      })

      setNormalizedCaffeineProducts(newCaffeineProducts)
    }
  }, [])

  return (
    <Container style={{ maxWidth: 640 }}>
      <Grid
        container
        spacing={3}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: 900,
        }}
      >
        {normalizedCaffeineProducts.map(item => {
          return (
            <Grid
              item
              key={item.id}
            >
              <CaffeinePressable
                onClick={() => handleSelectOption({ option: item })}
                imgOption={<CaffeineOptions tag={item.imgTag} />}
                nameOption={item.name}
                caffeineQty={item.isNoCaffeine ? null : item.description}
                isSelected={isSelected({ optionId: item.id })}
                disableOptions={disableOptions}
              />
            </Grid>
          )
        })}
      </Grid>
    </Container>
  )
}

export default CaffeinePressableList
